import { api } from "@/lib/api";

export const PartnerAPI = {
    // Catalog
    catalog: (preview = false) =>
        api.get(`/partner/catalog${preview ? "?preview=true" : ""}`).then((r) => r.data),
    saveProductDraft: (slug, patch) =>
        api.put(`/partner/catalog/${slug}`, patch).then((r) => r.data),
    discardProductDraft: (slug) =>
        api.delete(`/partner/catalog/${slug}/draft`).then((r) => r.data),
    publishProduct: (slug) =>
        api.post(`/partner/catalog/${slug}/publish`).then((r) => r.data),

    // Branding
    branding: (preview = false) =>
        api.get(`/partner/branding${preview ? "?preview=true" : ""}`).then((r) => r.data),
    saveBrandingDraft: (patch) =>
        api.put(`/partner/branding`, patch).then((r) => r.data),
    discardBrandingDraft: () =>
        api.delete(`/partner/branding/draft`).then((r) => r.data),
    publishBranding: () =>
        api.post(`/partner/branding/publish`).then((r) => r.data),

    // Drafts summary
    drafts: () => api.get(`/partner/drafts`).then((r) => r.data),

    // Change log + revert
    changes: () => api.get(`/partner/changes`).then((r) => r.data),
    revert: (id) => api.post(`/partner/changes/${id}/revert`).then((r) => r.data),

    // Paid change requests
    paidCategories: () =>
        api.get(`/partner/paid-change-catalog`).then((r) => r.data),
    submitChangeRequest: (payload) =>
        api.post(`/partner/paid-change-request`, payload).then((r) => r.data),
    changeRequests: () =>
        api.get(`/partner/change-requests`).then((r) => r.data),

    // Problem reports
    reportProblem: (payload) =>
        api.post(`/partner/problem-reports`, payload).then((r) => r.data),
    problemReports: () =>
        api.get(`/partner/problem-reports`).then((r) => r.data),

    // Fleet services
    fleetServices: () =>
        api.get(`/partner/fleet-services`).then((r) => r.data),

    // FAQ
    faq: () => api.get(`/partner/faq`).then((r) => r.data),

    // Entity status + reserve
    entityStatus: () =>
        api.get(`/partner/entity-status`).then((r) => r.data),

    // Amendment acknowledgment
    amendmentStatus: () =>
        api.get(`/partner/agreement/amendment-status`).then((r) => r.data),
    acknowledgeAmendments: (operator_version) =>
        api
            .post(`/partner/agreement/acknowledge-amendments`, { operator_version })
            .then((r) => r.data),

    // MSA export — fetch authenticated HTML, open as blob in a new tab
    openMsaExport: async () => {
        const resp = await api.get(`/partner/msa/export`, {
            responseType: "text",
            transformResponse: [(d) => d],
        });
        const blob = new Blob([resp.data], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        const w = window.open(url, "_blank", "noopener,noreferrer");
        if (!w) {
            // Pop-up blocked — fall back to download
            const a = document.createElement("a");
            a.href = url;
            a.download = "island-gold-msa.html";
            a.click();
        }
        // Revoke after a tick so the new window can finish loading
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
    },

    // Affiliate Hub
    affiliateMe: () => api.get(`/partner/affiliate/me`).then((r) => r.data),
    affiliateStats: () =>
        api.get(`/partner/affiliate/stats`).then((r) => r.data),
    affiliateTerms: () =>
        api.get(`/partner/affiliate/agreement/terms`).then((r) => r.data),
    affiliateSign: () =>
        api.post(`/partner/affiliate/sign`, { accepted: true }).then((r) => r.data),
    affiliateTrack: (slug) =>
        api.get(`/partner/affiliate/track/${slug}`).then((r) => r.data),
};
